import { Injectable } from '@angular/core';
import { USER_PREFERENCE_KEY } from './UserPreference.Contract';
import { storageAvailable } from 'rev-shared/util/BrowserFeature.Service';

@Injectable({
	providedIn: 'root'
})
export class UserPreferenceStoreService {
	public isLocalStorageAvailable = true;

	constructor() {
		this.isLocalStorageAvailable = storageAvailable('localStorage');
		if (!this.isLocalStorageAvailable) {
			console.warn('Local storage is not available. User preferences will not be saved.');
		}
	}

	public getPreference<T>(key: USER_PREFERENCE_KEY): T {
		try {
			return JSON.parse(localStorage.getItem(key));
		}
		catch (e) {
			console.error(e);
			return null;
		}
	}

	public setPreference<T>(key: USER_PREFERENCE_KEY, value: T): void {
		if (!this.isLocalStorageAvailable) {
			return;
		}

		if (value == null) {
			localStorage.removeItem(key); // Remove key if value is undefined
			return;
		}

		localStorage.setItem(key, JSON.stringify(value));
	}
}
